import { DatePicker, Flex, Select, Space } from "antd"
import { useMemo } from "react"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import dayjs from "dayjs"

interface FiltersProps {
  setDateRange: (dateRange: { startDate: string; endDate: string }) => void
  dateRange: { startDate: string; endDate: string }
  setAsin: (asin: string) => void
  asin: string
}

const Filters: React.FC<FiltersProps> = ({ setDateRange, dateRange, setAsin, asin }) => {
  const { projectData } = useTypedSelector((state) => state.projectDataSettings)
  function handleDateChange(datesString: [string, string]) {
    setDateRange({
      startDate: datesString[0],
      endDate: datesString[1],
    })
  }

  const asinsOptions = useMemo(
    () =>
      projectData.asins.map((asin) => {
        return {
          label: asin.asin,
          value: asin.asin,
        }
      }),
    [projectData.asins]
  )

  return (
    <Flex justify="space-between">
      <Select options={asinsOptions} onChange={setAsin} value={asin} />
      <DatePicker.RangePicker
        onChange={(dates, dateStrings) => handleDateChange(dateStrings)}
        value={[dayjs(dateRange.startDate), dayjs(dateRange.endDate)]}
      />
    </Flex>
  )
}

export default Filters
